import { render, staticRenderFns } from "./TheProductCustomizerMainSelector.vue?vue&type=template&id=3c500538&"
import script from "./TheProductCustomizerMainSelector.vue?vue&type=script&lang=js&"
export * from "./TheProductCustomizerMainSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../sfra-webpack-builder/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/sfra-webpack-builder/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3c500538')) {
      api.createRecord('3c500538', component.options)
    } else {
      api.reload('3c500538', component.options)
    }
    module.hot.accept("./TheProductCustomizerMainSelector.vue?vue&type=template&id=3c500538&", function () {
      api.rerender('3c500538', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app_byl_core/cartridges/app_byl_core/cartridge/client/default/js/vue/components/customizer/TheProductCustomizerMainSelector.vue"
export default component.exports